
const MapItemsObjectiveFindings = ({ items, type, objectiveFinding}) => {
  return(
    <>
    {items.map(item => {
      let fieldStart = `${type}_${item}`;
      let selectedOption = ['Severe', 'Moderate', 'Mild', 'None'].find(opt => objectiveFinding?.[`${fieldStart}${opt}`] === 'true');

      return (
      <div className="d-flex align-items-center gap-01">
        <p className="heading ar_dot">{item}:</p>
        <p className="text">{selectedOption || <p className="text ar-light-color">N/A</p>}</p>
      </div>)
      })}
    </>
  )
}
export default MapItemsObjectiveFindings;